/**
 * Owner: Masa Bayu
 * File: spsu-fonts-css.ts
 * Date:Time: 2026-10-24 00:00
 * Description: D2 pecahan modul · CSS family resolve + stack OCR. SoT = badan pakej
 *   (Times-first, §449-F1). Cabang kabur profil dibuang: 0 pemanggil produksi.
 */

import { listFontAssets, matchesFontQuery } from './spsu-fonts-asset';
import type { AssetLibrary } from '../extract/spsu-types';

/**
 * §449-F1 · Georgia tidak boleh memimpin stack. Ia ada di macOS/Windows dan lebih
 * lebar daripada serif sumber, jadi setiap perenggan dapat +1 baris dan jurang
 * antara perenggan (yang dikodkan pada y mutlak) termakan — pada p07 teks melukis
 * 14.45pt melebihi kotak perenggan (426.40 vs 411.95). Times dan gantinya yang
 * metrik-compatible memulangkan kiraan baris sumber (p07: 5/7/6/6).
 */
export const FALLBACK_STACK =
  '"Times New Roman", Times, "Liberation Serif", Tinos, Georgia, serif';

/**
 * Map measured / pdf.js font id → CSS family from AssetLibrary fonts.
 * Unresolved pdf.js tags without a font asset → serif fallback (no invent).
 */
export function resolveCssFontFamily(fontFamily: string, assets: AssetLibrary): string {
  const family = fontFamily.trim();
  if (family.length === 0 || family === 'unresolved') {
    return FALLBACK_STACK;
  }
  for (const asset of listFontAssets(assets)) {
    const info = asset.font!;
    if (matchesFontQuery(info, family)) {
      return `"${info.familyName}", ${FALLBACK_STACK}`;
    }
  }
  if (family.startsWith('g_d0_') || family.includes('+')) {
    return FALLBACK_STACK;
  }
  return `"${family}", ${FALLBACK_STACK}`;
}

/**
 * Teks OCR tiada provenance glif: glifnya datang daripada bitmap, jadi
 * `style.fontFamily` hanyalah tekaan pdf.js dan aset sepadan ialah subset PDF.
 * Diukur pada cmap (pid 3 / eid 1) fail subset: Calibri hanya 12–15 codepoint,
 * sementara 36/36 elemen OCR pada 4 halaman ber-OCR (p06/p07/p18/p19) perlukan
 * 38–50 aksara berbeza — setiap elemen mempunyai glif yang tiada. Meletakkan
 * keluarga aset di hadapan stack membuat pelayar ganti per-aksara secara senyap
 * kepada keluarga seterusnya. Keluarga aset dilangkau untuk teks OCR.
 */
export function resolveOcrTextFontFamily(): string {
  return FALLBACK_STACK;
}
